import { getSubscriptionAnalytics, getWebHook } from "../../api/HttpApis";
import { formatDate } from "../../utils/dateFormatter";
import styles from "../subscription/Subscription.module.css";
export const getAnalyticsData = async () => {
  try {
    const response = await getSubscriptionAnalytics();

    const analytics = response?.data || {};

    const monthlyRevenue = analytics.monthly_revenue || 0;
    const activeSubscriptions = analytics.active_subscriptions || 0;
    const trialUsers = analytics.trial_users || 0;
    const totalSubscriptions = analytics.total_subscriptions || 0;
    const totalRevenue = (analytics.revenue_metrics || []).reduce(
      (sum, item) => sum + (item.revenue || 0),
      0
    );
    const totalUsers = totalSubscriptions;
    const averageRevenuePerUser = totalUsers > 0
      ? totalRevenue / totalUsers
      : 0;

    return {
      totalSubscriptions,
      activeSubscriptions,
      monthlyRevenue: `$ ${monthlyRevenue.toFixed(2)}`,
      // NOTE: this is a count of users currently in a free trial, not
      // cancelled users — the backend has no cancelled-count in this
      // endpoint today. Named/labeled accordingly wherever it's displayed.
      trialUsers,
      active: activeSubscriptions,
      trial: trialUsers,
      total: totalSubscriptions,
      averageRevenuePerUser: `$${averageRevenuePerUser.toFixed(2)}`,
    };
  } catch (error) {
    console.error("Failed to fetch analytics data:", error);
    return {
      totalSubscriptions: 0,
      activeSubscriptions: 0,
      monthlyRevenue: "$0.00",
      trialUsers: 0,
      active: 0,
      trial: 0,
      total: 0,
      averageRevenuePerUser: "$0.00",
    };
  }
};

export const getWebhookData = async (page, perpage) => {
  try {
    const response = await getWebHook(page, perpage);

    const data = Array.isArray(response?.events) ? response.events : [];
    const total = response?.pagination?.total || data.length;

    const formattedData = data.map((item) => ({
      timestamp: formatDate(item.created_at),
      event: item.payload?.eventType || item.event_type,
      status: item.payload?.result?.status || "N/A",
      payload: {
        transactionId: item.payload?.result?.transactionId || "N/A",
        planName: item.payload?.result || "N/A",
        subscriptionId:
          item.payload?.result?.subscription_id ||
          item.subscription_id ||
          "N/A",
        customerId: item.payload?.jwtPayload?.rokuMessage?.customerId || "N/A",
      },
    }));

    return { data: formattedData, total };
  } catch (error) {
    console.error("Error fetching webhook data:", error);
    return { data: [], total: 0 };
  }
};

export const WebhookColumns = () => [
  { key: "timestamp", label: "Timestamp" },
  { key: "event", label: "Event" },
  {
    key: "status",
    label: "Status",
    render: (item) => (
      <span
        className={`${styles["webhook-status"]} ${
          item.status === "success" ? styles["success"] : styles["error"]
        }`}
      >
        {item.status}
      </span>
    ),
  },
  {
    key: "payload",
    label: "Payload",
    render: (item) => (
      <pre className={styles["payload-box"]}>
        {JSON.stringify(item.payload, null, 2)}
      </pre>
    ),
  },
];

// "Promos" intentionally hidden (2026-05-20) — the tab and underlying CMS
// flow work, but the launch-promo logic isn't yet wired into Stripe Checkout.
// Until the client confirms the $2.99 / 90-day semantics and we connect it
// to actual billing, admins setting promos here would see no effect at
// purchase time. Restore by adding "Promos" back to the array.
export const subscriptionTabs = ["Subscriptions", "Plans", "Webhooks", "Settings", "Analytics"];